import React, { Fragment } from "react";
import externalLink from "../../../assets/images/external-link.png";
import { Link } from "react-router-dom";

const SampleLibraryList = props => {

    return (
        <Fragment>

            <table id="sampleLibTable">

                <tr>
                    <div className="row">
                        {props.list !== undefined &&
                            Array.isArray(props.list) &&
                            props.list.length > 0 &&
                            props.list.map(listValue => {
                                return (
                                    <Fragment>
                                        <div className=" col-md-3 ">

                                            <td><Link onClick={() => {
                                                if (
                                                    !props.styleRights.web.edit &&
                                                    !props.styleRights.web.view
                                                ) {
                                                    props.getalertMessage(
                                                        "info",
                                                        "no access"
                                                    )
                                                } else {
                                                    let action = (props.styleRights.web.edit && "edit") || (props.styleRights.web.view && "view");
                                                    let search = "?" + new URLSearchParams({
                                                        action: action,
                                                        _id: listValue._id
                                                    }).toString()
                                                    window.open(`/StylePage${search}#seleted${listValue.styleNumber.split("-").join("")}`, "_blank")                                                    
                                                }
                                            }}><b style={{color:"black"}}>{listValue.styleNumber} - {listValue.styleName || "STYLE IMAGE"}</b></Link></td>
                                            <div className="row ">
                                                <div className="col-md-auto ">
                                                    <td className="p-1">
                                                        <img
                                                            className="sample-library-report-img"
                                                            onClick={() =>
                                                                props.modalData(listValue.imageUrl)

                                                            }
                                                            src={listValue.imageUrl}
                                                        />
                                                    </td>

                                                </div>
                                                <div className="col-md-4">
                                                    <div>
                                                        <td className="p-0">Name-Type: {listValue.imageName}</td>
                                                    </div>
                                                    {/* <div>
                                                        <td className="p-0"> Date </td>
                                                    </div> */}

                                                </div>
                                            </div>
                                        </div>



                                    </Fragment>
                                )
                            })}
                    </div>
                </tr>

            </table>
        </Fragment>
    );
};

export default SampleLibraryList


// WEBPACK FOOTER //
// ./src/components/Report/reports/sampleLibraryList.js